import React, {useEffect, useRef, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {
  constants,
  getNumberOrNull,
  prepareDatosAuxOptions,
  prepareEmpresasOptions,
  responseSelector,
  toTitleCase,
} from '../utils/utils';
import {useAlerts} from '../ui/alert';
import {alertTypes} from '../utils/Alert';
import {log} from '../utils/logs';
import {
  createEmpresaDuck,
  createEmpresaThunk,
  searchEmpresasByNameDuck,
  searchEmpresasByNameThunk,
} from './duck';
import {CrearEmpresaView} from './CrearEmpresaView';
import {
  getEmpresasDuck,
  getEmpresasThunk,
  getRubrosDuck,
  getRubrosThunk,
  getCargosThunk,
  getCargosDuck,
} from '../oportunidades/duck';

function CrearEmpresa({history, match, token}) {
  const dispatch = useDispatch();

  const modelGetRubros = useSelector(state => state.getRubros);
  const modelCreateEmpresa = useSelector(state => state.createEmpresa);
  const modelGetEmpresas = useSelector(state => state.getEmpresas);
  const modelGetCargos = useSelector(state => state.getCargos);
  const modelSearchEmpresasByName = useSelector(
    state => state.searchEmpresasByName,
  );

  const [grupoEmpresarialOptions, setGrupoEmpresarialOptions] = useState([]);
  const [grupoEmpresarialOption, setGrupoEmpresarialOption] = useState();

  const [nombre, setNombre] = useState('');
  const [direccion, setDireccion] = useState('');
  const [telefono, setTelefono] = useState('');
  const [correo, setCorreo] = useState('');
  const [razonSocial, setRazonSocial] = useState('');
  const [documento, setDocumento] = useState('');
  const [gerenteGral, setGerenteGral] = useState('');
  const [gerenteGralTelefono, setGerenteGralTelefono] = useState('');
  const [gerenteGralEmail, setGerenteGralEmail] = useState('');
  const [gerenteRrhh, setGerenteRrhh] = useState('');
  const [gerenteRrhhTelefono, setGerenteRrhhTelefono] = useState('');
  const [gerenteRrhhEmail, setGerenteRrhhEmail] = useState('');
  const [esCliente, setEsCliente] = useState(false);
  const [esGrupo, setEsGrupo] = useState(false);
  const [rubrosOptions, setRubrosOptions] = useState();
  const [rubroOption, setRubroOption] = useState();
  const [contactoNombre, setContactoNombre] = useState('');
  const [contactoTelefono, setContactoTelefono] = useState('');
  const [foundEmpresas, setFoundEmpresas] = useState([]);
  const [cargosOptions, setCargosOptions] = useState([]);
  const [cargoOption, setCargoOption] = useState();
  const [emailContacto, setEmailContacto] = useState('');
  const [director, setDirector] = useState('');
  const [directorTelefono, setDirectorTelefono] = useState('');
  const [directorEmail, setDirectorEmail] = useState('');
  const [gerenteComercial, setGerenteComercial] = useState('');
  const [gerenteComercialTelefono, setGerenteComercialTelefono] = useState('');
  const [gerenteComercialEmail, setGerenteComercialEmail] = useState('');
  const [contactoNombreServicio, setContactoNombreServicio] = useState('');
  const [contactoTelefonoServicio, setContactoTelefonoServicio] = useState('');
  const [cargoOptionServicio, setCargoOptionServicio] = useState();
  const [emailContactoServicio, setEmailContactoServicio] = useState('');

  const {topAlert, setTopAlert, submitAlert, setSubmitAlert} = useAlerts();

  const timer = useRef(null);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetCargos);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getCargosDuck.actions.clear());
    }

    if (data) {
      const datosAuxOptions = prepareDatosAuxOptions(data.items);

      setCargosOptions(datosAuxOptions);

      dispatch(getCargosDuck.actions.clear());
    }
  }, [modelGetCargos]);

  useEffect(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    if (nombre && nombre.length > 2) {
      timer.current = setTimeout(() => {
        dispatch(
          searchEmpresasByNameThunk({
            name: nombre,
            userToken: token.raw,
          }),
        );
      }, 2000); // 2 seconds delay
    }
  }, [nombre]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelSearchEmpresasByName);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(searchEmpresasByNameDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      dispatch(searchEmpresasByNameDuck.actions.clear());
      setFoundEmpresas(data);
    }
  }, [modelSearchEmpresasByName]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetEmpresas);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getEmpresasDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      dispatch(getEmpresasDuck.actions.clear());

      setGrupoEmpresarialOptions([
        {value: null, label: 'Sin grupo'},
        ...prepareEmpresasOptions(data.items),
      ]);
    }
  }, [modelGetEmpresas]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelCreateEmpresa);

    if (error) {
      setSubmitAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(createEmpresaDuck.actions.clear());
    }

    if (data) {
      dispatch(createEmpresaDuck.actions.clear());

      setSubmitAlert({
        text: 'Empresa creada correctamente',
        type: alertTypes.success,
        closable: false,
      });

      history.push(`/empresa/editar/${data.idNumerico}`);
    }
  }, [modelCreateEmpresa]);

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelGetRubros);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getRubrosDuck.actions.clear());
    }

    if (data) {
      // log({ 'modelGetRubros.useEffect.data': data });

      const datosAuxOptions = prepareDatosAuxOptions(data.items);
      // log({ datosAuxOptions });

      setRubrosOptions([{value: null, label: 'Ninguno'}, ...datosAuxOptions]);

      dispatch(getRubrosDuck.actions.clear());
    }
  }, [modelGetRubros]);

  useEffect(() => {
    dispatch(
      getEmpresasThunk({
        esGrupo: 'SI',
        userToken: token.raw,
      }),
    );
    dispatch(
      getRubrosThunk({
        userToken: token.raw,
      }),
    );
    dispatch(
      getCargosThunk({
        userToken: token.raw,
      }),
    );
  }, []);

  function submit() {
    let data = {
      userToken: token.raw,
      nombre,
      direccion,
      telefono,
      correo,
      razonSocial,
      documento,
      gerenteGral,
      gerenteGralTelefono,
      gerenteGralEmail,
      gerenteRrhh,
      gerenteRrhhTelefono,
      gerenteRrhhEmail,
      esCliente,
      esGrupo,
      rubroIdNumerico: rubroOption?.value,
      contactoNombre,
      contactoTelefono,
      contactoCargo: cargoOption?.value,
      contactoCargoNombre: cargoOption?.label,
      contactoEmail: emailContacto,
      contactoServicioNombre: contactoNombreServicio,
      contactoServicioTelefono: contactoTelefonoServicio,
      contactoServicioCargo: cargoOptionServicio?.value,
      contactoServicioCargoNombre: cargoOptionServicio?.label,
      contactoServicioEmail: emailContactoServicio,
      director,
      directorTelefono,
      directorEmail,
      gerenteComercial,
      gerenteComercialTelefono,
      gerenteComercialEmail,
      empresaPadreId: grupoEmpresarialOption?.value,
    };

    log({'submit.data': data});

    dispatch(createEmpresaThunk(data));
  }

  return (
    <CrearEmpresaView
      mode="create"
      history={history}
      match={match}
      modelCreateEmpresa={modelCreateEmpresa}
      submit={submit}
      submitAlert={submitAlert}
      topAlert={topAlert}
      nombre={nombre}
      setNombre={setNombre}
      direccion={direccion}
      setDireccion={setDireccion}
      telefono={telefono}
      setTelefono={setTelefono}
      correo={correo}
      setCorreo={setCorreo}
      razonSocial={razonSocial}
      setRazonSocial={setRazonSocial}
      documento={documento}
      setDocumento={setDocumento}
      gerenteGral={gerenteGral}
      setGerenteGral={setGerenteGral}
      gerenteGralTelefono={gerenteGralTelefono}
      setGerenteGralTelefono={setGerenteGralTelefono}
      gerenteGralEmail={gerenteGralEmail}
      setGerenteGralEmail={setGerenteGralEmail}
      gerenteRrhh={gerenteRrhh}
      setGerenteRrhh={setGerenteRrhh}
      gerenteRrhhTelefono={gerenteRrhhTelefono}
      setGerenteRrhhTelefono={setGerenteRrhhTelefono}
      gerenteRrhhEmail={gerenteRrhhEmail}
      setGerenteRrhhEmail={setGerenteRrhhEmail}
      esCliente={esCliente}
      setEsCliente={setEsCliente}
      esGrupo={esGrupo}
      setEsGrupo={setEsGrupo}
      contactoNombre={contactoNombre}
      setContactoNombre={setContactoNombre}
      contactoTelefono={contactoTelefono}
      setContactoTelefono={setContactoTelefono}
      rubroOption={rubroOption}
      rubrosOptions={rubrosOptions}
      setRubroOption={setRubroOption}
      grupoEmpresarialOptions={grupoEmpresarialOptions}
      grupoEmpresarialOption={grupoEmpresarialOption}
      setGrupoEmpresarialOption={setGrupoEmpresarialOption}
      foundEmpresas={foundEmpresas}
      modelSearchEmpresasByName={modelSearchEmpresasByName}
      director={director}
      setDirector={setDirector}
      directorTelefono={directorTelefono}
      setDirectorTelefono={setDirectorTelefono}
      directorEmail={directorEmail}
      setDirectorEmail={setDirectorEmail}
      cargoOption={cargoOption}
      cargosOptions={cargosOptions}
      setCargoOption={setCargoOption}
      emailContacto={emailContacto}
      setEmailContacto={setEmailContacto}
      contactoNombreServicio={contactoNombreServicio}
      setContactoNombreServicio={setContactoNombreServicio}
      contactoTelefonoServicio={contactoTelefonoServicio}
      setContactoTelefonoServicio={setContactoTelefonoServicio}
      cargoOptionServicio={cargoOptionServicio}
      setCargoOptionServicio={setCargoOptionServicio}
      emailContactoServicio={emailContactoServicio}
      setEmailContactoServicio={setEmailContactoServicio}
      gerenteComercial={gerenteComercial}
      setGerenteComercial={setGerenteComercial}
      gerenteComercialTelefono={gerenteComercialTelefono}
      setGerenteComercialTelefono={setGerenteComercialTelefono}
      gerenteComercialEmail={gerenteComercialEmail}
      setGerenteComercialEmail={setGerenteComercialEmail}
    />
  );
}

export {CrearEmpresa};
